//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import epgNav from '~/components/content/epg/epgNav';
    import epgItem from '~/components/content/epg/epg.vue'
    import dummyItem from '~/components/content/dummy/epg_dummy.vue'

    export default {
      async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'tv-gids'),
            this.$store.dispatch('epgStore/getEpg', this.queries.epg)
            ])
    },
    head() {
      return {
        title: this.pages.tvgids ? this.pages.tvgids.seo.title : 'TV Gids | Secret Circle',
        meta: [
          { hid: 'title', name: 'title', content: this.pages.tvgids ? this.pages.tvgids.seo.title : 'TV Gids | Secret Circle' },
          { hid: 'og:title', name: 'og:title', content: this.pages.tvgids ? this.pages.tvgids.seo.title : 'TV Gids | Secret Circle' },
          { hid: 'description', name: 'description', content: this.pages.tvgids ? this.pages.tvgids.seo.description : 'Nu te zien op televisie bij Secret Circle'},
          { hid: 'og:description', name: 'og:description', content: this.pages.tvgids ? this.pages.tvgids.seo.description : 'Nu te zien op televisie bij Secret Circle' },
          { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/tv-gids' },
          { hid: 'keywords', name: 'keywords', content: this.pages.tvgids ? this.pages.tvgids.seo.keywords : 'tvgids, gids, epg'},
          ]
    }
},
components: {
    epgNav,
    epgItem,
    dummyItem
},
data() { 
    return {
    };
},
computed: {
    ...mapState({
        pages: ({ pagesStore: {pages} }) => pages,
        queries: ({ epgStore: {queries} }) => queries,
        epg: ({ epgStore: {epg} }) => epg,
        loading: ({ epgStore: {loading} }) => loading
    }),
},
mounted: function() {
    if (!this.epg || this.epg.length < 0) {
        this.$store.dispatch('epgStore/getEpg', this.queries.epg)
    }
},
methods: {

}
}
